import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { programConfig } from '../../../../common/constants/appConstants'
import { useAssignmentsData } from '../../../assignments/data/hooks/useAssignmentsData'
import { useSelectedEpisodeForClient } from '../../../episodes/data/hooks/useSelectedEpisodeForClient'

export const useIntakeForm = () => {
  const { data: selectedEpisode } = useSelectedEpisodeForClient() as { data: Episode | undefined }
  const episodeProgramConfig = selectedEpisode?.program_name ? programConfig[selectedEpisode.program_name] : undefined
  const clientIntake = episodeProgramConfig?.clientIntake
  const oldClientIntake = episodeProgramConfig?.oldClientIntake
  const { data: assignments } = useAssignmentsData()

  return assignments?.find((assignment) => {
    return (
      [clientIntake, oldClientIntake].includes(assignment.content.name) && assignment.episode_id === selectedEpisode?.id
    )
  })
}
